var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17353",
    d: "M16 16h-.076a2.072 2.072 0 01-.487-.079 1.987 1.987 0 01-.761-.421L.7 3.519A2 2 0 013.3.482L16 11.366 28.7.482a2 2 0 012.6 3.037l-14 12A1.989 1.989 0 0116 16",
    fill: "currentColor"
  })));
}
export default SvgChevronDown;